import { Catalog } from '@df/catalog/catalog.interfaces';
import { IAddToBasketData } from '@df/session/api/basket/basket';
import { BasketItem } from '@df/session/api/basket/basket-item';
export namespace BasketAddNotice {
    export const basketAddNoticeModalId = 'basket-add-notice-modal';
    export interface IModalData {
        basketItem: BasketItem;
        request: IAddToBasketData;
        addedItemsQty: number;
        giftItem?: BasketItem;
    }
    /**
     * Modal bLock data
     */
    export type IBlockData = Catalog.IBlockData<IBlockContent>;
    /**
     * Modal block content
     */
    export interface IBlockContent {
        klevu_recommendations_id?: string;
    }
}
